/**
 * 权限管理接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 权限管理接口
  /**
   * 加载权限管理
   * @param param
   * @returns {Observable<any>}
   */
  queryDataPageList(param) {
    const url = this.prefix + 'data/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查看权限管理
   * @param param
   * @returns {Observable<any>}
   */
  getData(param) {
    const url = this.prefix + 'data/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 删除权限管理
   * @param param
   * @returns {Observable<any>}
   */
  deleteData(param) {
    const url = this.prefix + 'data/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 启用，禁用权限管理
   * @param param
   * @returns {Observable<any>}
   */
  updateData(param) {
    const url = this.prefix + 'data/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 保存权限管理
   * @param param
   * @returns {Observable<any>}
   */
  saveData(param) {
    const url = this.prefix + 'data/save';
    return this.http.Post(url, param);
  }

  /**
   * 查询用户
   * @param param
   * @returns {Observable<any>}
   */
  queryHiddenRoleByUserId(param) {
    const url = this.prefix + 'role/queryHiddenRoleByUserId';
    return this.http.Post(url, param);
  }

  /**
   * 查询role的角色（权限设置）
   * @param param
   * @returns {Observable<any>}
   */
  queryRoleDataByFk(param) {
    const url = this.prefix + 'roleData/queryByFk';
    return this.http.Post(url, param);
  }

  /**
   * 保存或删除role的角色（权限设置）
   * @param param
   * @returns {Observable<any>}
   */
  saveOrDeleteRoleData(param) {
    const url = this.prefix + 'roleData/saveOrDelete';
    return this.http.Post(url, param);
  }

  /**
   * 反选打钩-并缓存（权限设置）
   * @param param
   * @returns {Observable<any>}
   */
  queryDatasByUserId(key, systemId, param) {
    const url = this.prefix + 'data/queryDatasByUserId?userId=' + key + '&systemId=' + systemId;
    return this.http.Post(url, param);
  }

  //#endregion


}
